import * as React from 'react';
import { IFieldConfig } from '../../../../interface/field-config.interface';
import { Label } from '@atlaskit/field-base';
import { observer } from 'mobx-react';
import { Grading } from '../../../grading/grading';
import styled from 'styled-components';
import { BlockColorEnum } from '../../../../enum/block-color.enum';

interface IDateFieldProps {
  value: number;
  onChange: any;
  onBlur: any;
  labelColor: string;
  isInvalid: boolean;
}

const GradingWrapper = styled.div`
  position: relative;
  & label div {
     color: ${(props: { labelColor?: string }) => props.labelColor ? props.labelColor : BlockColorEnum.PrimaryTextColor};
  }
`;

export const GradingField = observer((props: IDateFieldProps & IFieldConfig) => {
  return (
    <GradingWrapper labelColor={props.labelColor}>
      <Label
        isRequired={props.required}
        htmlFor={props.applyFormKey}
        label={props.label}
      />
      <Grading
        disabled={props.disabled}
        name={props.applyFormKey}
        value={props.value}
        minValue={0}
        maxValue={props.maxIntegerValue}
        nullValueMin={0}
        nullValueMax={0}
        onChange={props.onChange}
        onBlur={props.onBlur}
        isInvalid={props.isInvalid}
      />
    </GradingWrapper>
  );
});
